module.exports = __webpack_public_path__ + "static/media/2_9.cc85a50c.png";